<template>
	<div class="box">
		<arrorImg bg="white"></arrorImg>
		<navBar title="选择优惠券" @returnCoupon="returnCoupon" color="#ffffff"></navBar>
		<div class="content-box">
			<div class="list-item" v-for="(item,index) in List" :key="index">
				<div class="conpon-item">
					<div>
						<span class="conpon-yuan">￥</span><span class="conpon-text">{{item.reduceMoney}}</span>
						<div class="counpon-center">
							<span class="conpon-count">满{{item.fullMoney}}可用</span>
							<span class="conpon-time">有效期至{{item.expireTime}}</span>
						</div>
					</div>
					<span class="conpon-btn" @click="routeCharge(item)">去使用</span>
					<!-- <span class="conpon-btndefault" >已领完</span> -->
				</div>
				<img v-if="item.overdueState==1"  src="../../../static/couponed_icon.png" alt="">
			</div>
			<div class="default-btn" @click="returnBack"><span>不使用优惠券</span></div>
		</div>
	</div>
</template>
<script>
	import {Toast, MessageBox } from "mint-ui";
	import arrorImg from "../../components/arrow-img.vue";
	import navBar from '../components/navbar.vue'
	export default {
			name:'chooseCoupons',
		components: {
			arrorImg,
			navBar
		},
		data() {
			return {
				List: [],
				chargeMoney: 0,
				pageType: '',
				couponId: 0,
				recommanId: 0, //
				isEntranceData:'',
				CouponStatus:''
			}
		},
		mounted() {
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData
			}
			if(this.$route.query.CouponStatus){
				this.CouponStatus=this.$route.query.CouponStatus;
			}
			this.couponId=this.$route.query.couponId;
			this.pageType=this.$route.query.pageType;
			this.chargeMoney=this.$route.query.chargeMoney;
			var openid =  this.$base.getStorage('openid')
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			  var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
				// #ifdef H5
				// #endif
			} else if(isWxAuthorized==0&&city==1&&openid&&!this.$store.state.user.isSNS){
				this.$base.setStorage('isSNS',true)
				this.$store.state.user.isSNS=true;
				this.$commonApi.snsapiUserinfo();
				this.usersReceiveCoupons();
			}else {
				this.usersReceiveCoupons();
			}
			 this.$base.setStorage('couponId',0)
			this.$commonApi.share();
			this.back();
		},
	
		methods: {
			back() {
				var that=this;
  window.addEventListener("popstate", function (e) {
	  if(e.isTrusted){
 that.$base.setStorage('couponStatus',that.CouponStatus)
	  }

  }, false);
},
			usersReceiveCoupons() {
				var params = {
					isRechargePage: 0
				}
				this.$api.usersReceiveCoupons(params).then(res => {
					if (res.status == 1) {
						this.List = res.data.couponReturnDTO;
						this.recommanId = this.$base.choicelessCoupons(this.List, this.chargeMoney)
						this.insertPageAccessData();
					
					}
				})
			},
			routeCharge(item){
				 this.$base.setStorage('couponStatus',1)
				 this.$base.setStorage('couponId',item.id)
			this.$router.back()
			},
			returnBack(){
				  this.$base.setStorage('couponStatus',2)
				   this.$base.setStorage('couponId',0)
				//    history.back()
				  this.$router.back()
			},
			returnCoupon(){
				 this.$base.setStorage('couponStatus',this.CouponStatus)
				 this.$router.back()
			},
			insertPageAccessData(){
				var prevPage='';
				if (this.pageType === "bookCharge") {
					prevPage = "充值页";
				} else if (this.pageType === "bookCity") {
					prevPage = "书城";
				} 
				 var params = {
				      pageName: '选择优惠券',
					  pageRemark: '上级页面：'+prevPage,
					  isEntranceData:this.isEntranceData
				    }
				this.$api.insertPageAccessData(params).then(res=>{
					
				})
			},
		}
	}
</script>

<style scoped>

.content-box{
	overflow: hidden;
	padding-top: calc(44px + env(safe-area-inset-top));
}
	.box {
		min-height: 100%;
		padding: 18px;
		background-color: #f3f3f3;
	}

	.view-tip>text {
		font-size: 12px;
		color: #FFFFFF;
		display: block;
		margin-bottom: 6px;
		line-height: 17px;
	}

	.list-item {
		background-image: url(../../../static/coupon_bg.png);
		position: relative;
		background-repeat: no-repeat;
		background-size: cover;
		padding: 24px 16px;
		box-sizing: border-box;
		margin-bottom: 16px;
		border-radius: 12px;
	}

	.list-item>img {
		width: 40px;
		height: 38px;
		position: absolute;
		left: 0px;
		top: 0px;
	}

	.conpon-item {
		display: flex;
		justify-content: space-between;
	}

	.conpon-item>div {
		display: flex;
	}

	.counpon-center>span {
		display: block;
		margin-left: 7px;
	}

	.conpon-yuan {
		font-size: 14px;
		color: #de3b34;
		line-height:40px;
	}

	.conpon-text {
		font-size: 28px;
		color: #de3b34;
		font-weight: bold;
		width: 51px;
	}

	.conpon-count {
		font-size: 16px;
		font-weight: bold;
		color: #333333;
	}

	.conpon-time {
		font-size: 11px;
		color: #aaaaaa;
		margin-top: 3px;
	}

	.conpon-btn {
		background-color: #de3b34;
		border-radius: 12px;
		width: 58px;
		height: 24px;
		font-size: 12px;
		text-align: center;
		line-height: 24px;
		color: #ffffff;
		margin-top: 10px
	}

	.conpon-default>div>.conpon-yuan,
	.conpon-default>div>.conpon-text,
	.conpon-default>div>div>.conpon-count {
		color: #aaaaaa;
	}

	.conpon-btndefault {
		font-size: 12px;
		color: #aaaaaa;
	}

	.default-btn {
		background-color: #ffffff;
		border-radius: 8px;
		padding: 12px;
		width: 100%;
		box-sizing: border-box;
		margin-top: 20px;
		text-align: center;
	}

	.default-btn>span {
		font-size: 12px;
		color: #aaaaaa;
	}
</style>



// WEBPACK FOOTER //
// src/view/chooseCoupons/index.vue